export const TRIP_STATUS = {
  DRAFT: 0,
  ARRANGING: 3,
  COMPLETED: 4,
  CANCELLED: 5
} as const;

export const TRIP_STATUS_LABELS: Record<number, string> = {
  [TRIP_STATUS.DRAFT]: 'AI予約モード',
  [TRIP_STATUS.ARRANGING]: '手配中',
  [TRIP_STATUS.COMPLETED]: '手配完了',
  [TRIP_STATUS.CANCELLED]: 'キャンセル'
};

export const getTripStatusLabel = (status: number | undefined, draft: boolean | undefined): string => {
  if (draft) {
    return TRIP_STATUS_LABELS[TRIP_STATUS.DRAFT];
  }
  if (status !== undefined && status in TRIP_STATUS_LABELS) {
    return TRIP_STATUS_LABELS[status];
  }
  return TRIP_STATUS_LABELS[TRIP_STATUS.DRAFT];
};
